<script lang="ts" setup>
import { ArrowRightIcon } from "@heroicons/vue/20/solid";
import { formatDate, getWeekNumber } from "@/utils/date";
import { IAuftrag } from "../api/useAuftraege";

defineProps<{ auftrag: IAuftrag }>();
</script>

<template>
  <div class="relative whitespace-normal group">
    <div class="block w-full px-4 py-2 bg-white shadow-md print:shadow-none">
      <router-link
        :to="{ name: 'fahrer-auftrag', params: { auftragId: auftrag.id } }"
        class="flex items-center leading-tight"
      >
        <div>
          <span class="block font-medium tracking-wide text-gray-800">
            {{ auftrag.abholung.name }}
          </span>
        </div>
        <div class="mx-3">
          <ArrowRightIcon class="w-5 h-5 text-gray-800" />
        </div>
        <div>
          <span class="block font-medium tracking-wide text-gray-800">
            {{ auftrag.anlieferung.name }}
          </span>
        </div>
        <div class="self-end ml-auto text-xs divide-x">
          <span class="pl-2">
            {{ formatDate(auftrag.abholung.datum) }}
            (KW{{ getWeekNumber(auftrag.abholung.datum) }})
          </span>
        </div>
      </router-link>
    </div>
  </div>
</template>
